module.exports = __webpack_public_path__ + "site-build/img/icon-4.207195a2.svg";